export interface User {
  id: string
  tenantId: string
  email: string
  name?: string
  image?: string
  role: UserRole
  authProvider?: string
  emailVerified?: Date
  createdAt: Date
  updatedAt: Date
}

export interface Tenant {
  id: string
  name: string
  slug: string
  industry?: string
  description?: string
  subscriptionPlan: string
  creditsRemaining: number
  createdAt: Date
  updatedAt: Date
}

export interface BusinessProfile {
  id: string
  tenantId: string
  companyName: string
  description?: string
  industry?: string
  brandColors?: {
    primary: string
    secondary: string
  }
  toneOfVoice?: string
  targetAudience?: {
    description: string
    demographics?: any
  }
  contentPreferences?: {
    topics: string[]
    contentTypes?: string[]
  }
  brandGuidelines?: string
  createdAt: Date
  updatedAt: Date
}

export interface Session {
  user: {
    id: string
    name?: string
    email?: string
    image?: string
    role: UserRole
    tenant: {
      id: string
      name: string
      slug: string
      creditsRemaining: number
    }
  }
  expires: string
}

export interface JWTPayload {
  sub: string // user id
  email: string
  role: UserRole
  tenantId: string
  iat: number
  exp: number
}

export interface LoginRequest {
  email: string
  password: string
}

export interface LoginResponse {
  token: string
  user: {
    id: string
    email: string
    name?: string
    role: UserRole
    tenant: {
      id: string
      name: string
      slug: string
      creditsRemaining: number
    }
  }
}

export enum UserRole {
  ADMIN = 'ADMIN',
  EDITOR = 'EDITOR',
  VIEWER = 'VIEWER'
}

export interface DemoAccount {
  id: string
  email: string
  password: string
  name: string
  tenant: {
    id: string
    name: string
    slug: string
    industry: string
    creditsRemaining: number
  }
}